export const cfc = {
    fontFamilyImport: [],
  transitionMain: "all 300ms ease-in-out",

  fieldTopSpacing: 19,
  inputPaddingInline: 15,

  inputHeight: 42,
  inputWidth: '100',
  inputWidthUnits: "%",

  inputFontSize: 20,
  inputFontFamily: '"Roboto", sans-serif',
  inputColor: "#555555",
  inputBackgroundColor: "#ffffff",
  inputFontWeight: 500,

  inputBorderColor: "#555555",
  inputBorderWidth: 1,
  inputBorderRadius: 4,

  inputHoverColor: "#555555",
  inputHoverBorderColor: "#555555",
  inputHoverBackgroundColor: "#ffffff",

  // **********************************
  //  Select field
  selectTopSpacing: 19,
  selectPaddingInline: 15,

  selectHeight: 42,
  selectWidth: '100',
  selectWidthUnits: "%",

  selectFontSize: 20,
  selectFontFamily: '"Roboto", sans-serif',
  selectColor: "#555555",
  selectBackgroundColor: "#ffffff",
  selectFontWeight: 500,

  selectBorderColor: "#555555",
  selectBorderWidth: 1,
  selectBorderRadius: 4,

  selectHoverColor: "#555555",
  selectHoverBorderColor: "#555555",
  selectHoverBackgroundColor: "#ffffff",

  addSelectBackgroundImage: false,
  selectBackgroundImage: '',
  selectBackgroundImagePositionRight: 10,
  selectBackgroundImageSize: 20,

  // **********************************
  //  Text Area field
  textAreaTopSpacing: 19,
  textAreaPaddingInline: 15,

  textAreaHeight: 42,
  textAreaWidth: '100',
  textAreaWidthUnits: "%",

  textAreaFontSize: 20,
  textAreaFontFamily: '"Roboto", sans-serif',
  textAreaColor: "#555555",
  textAreaBackgroundColor: "#ffffff",
  textAreaFontWeight: 500,

  textAreaBorderColor: "#555555",
  textAreaBorderWidth: 1,
  textAreaBorderRadius: 4,

  textAreaHoverColor: "#555555",
  textAreaHoverBorderColor: "#555555",
  textAreaHoverBackgroundColor: "#ffffff",

  // **********************************
  //  placeholder
  placeholderColor: "#555555",
  placeholderFontFamily: '"Roboto", sans-serif',
  placeholderFontSize: 20,
  placeholderFontWeight: 500,
  placeholderHoverColor: "#555555",

  // **********************************
  // script
  addPlaceholders: false,
  removeFieldLabels: false,

  // **********************************
  //  field label
  fieldLabelBottomSpacing: 5,
  fieldLabelPadding: 0,
  fieldLabelFontSize: 20,
  fieldLabelColor: "#555555",
  fieldLabelFontWeight: 500,
  fieldLabelColorAsterisk: "#555555",
  fieldLabelAlignment: "column",
  fieldLabelFontFamily: '"Roboto", sans-serif',

  // **********************************
  //  description
  descriptionPaddingInline: 0,
  descriptionColor: "#555555",
  descriptionFontSize: 20,
  descriptionFontWeight: 400,
  descriptionFontFamily: '"Roboto", sans-serif',
  descriptionTopSpacing: 10,

  // **********************************
  // checkbox

  addCheckbox: false,
  checkedCheckboxContent: "",
  checkboxInputSize: 15,
  checkboxBorderWidth: 1,
  checkboxBorderRadius: 4,
  checkboxUncheckedBorderColor: "#555555",
  checkboxUncheckedBackgroundColor: "#ffffff",
  checkboxCheckedBackgroundColor: "#CF7019",
  checkboxCheckedBorderColor: "#555555",
  checkboxCheckedColor: "#ffffff",
  checkboxAlignment: "none",
  checkboxLabelFontFamily: '"Roboto", sans-serif',
  checkboxLabelFontSize: 20,
  checkboxLabelFontWeight: 500,
  checkboxLabelColor: "#555555",

  // **********************************
  // radio button

  addRadioButton: false,
  radioInputSize: 15,
  radioBorderWidth: 1,
  radioBorderRadius: 50,

  radioUncheckedBorderColor: "#555555",
  radioUncheckedBackgroundColor: "#ffffff",
  radioCheckedBackgroundColor: "#CF7019",
  radioCheckedBorderColor: "#555555",

  radioAlignment: "none",

  radioLabelFontFamily: '"Roboto", sans-serif',
  radioLabelFontSize: 20,
  radioLabelFontWeight: 500,
  radioLabelColor: "#555555",

  // **********************************
  // submit button

  submitMarginTop: 47,
  submitFontSize: 20,
  submitFontFamily: "'Roboto', sans-serif",
  submitWidth: 213,
  submitWidthUnits: "px",
  submitHeight: 53,
  submitBorderRadius: 4,
  submitBorderWidth: 1,
  submitBackground: "#CF7019",
  submitColor: "#ffffff",
  submitBorderColor: "#CF7019",
  submitBackgroundHover: "#CF7019",
  submitBorderColorHover: "#CF7019",
  submitColorHover: "#ffffff",
  submitTextAlign: "center",
  submitButtonText: "Submit",
  submitFontWeight: 500,
  addBackgroundImage: false,
  submitBackgroundImage: '',
  submitBackgroundImagePositionRight: 10,
  submitBackgroundImageSize: 20,
  submitButtonAlign: "center",
};

  